var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M14.5687 29.7825H74.36C78.7775 29.7825 80.9486 28.2905 82.1388 26.8068C82.1388 23.1102 79.1464 20.1177 75.4497 20.1177H13.3952C9.69855 20.1177 6.70605 23.1102 6.70605 26.8068C6.70605 26.8068 8.48311 29.7825 14.5687 29.7825Z",
    fill: "url(#paint0_linear_197_6814)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M82.1471 42.3561C80.8478 43.2028 79.2468 42.7585 79.2971 41.8197C79.339 41.0401 79.3138 31.962 79.2971 28.9192C78.0732 29.4389 76.4722 29.7826 74.3599 29.7826V95.5589H75.4579C79.1546 95.5589 82.1471 92.5664 82.1471 88.8698V77.1764L102.717 90.6133H109.306V27.5613H102.86L82.1471 42.3645V42.3561Z",
    fill: "url(#paint1_linear_197_6814)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M102.718 25.0633L82.1474 38.5002V26.8068C81.5271 27.5864 80.6386 28.3576 79.3058 28.9192C79.3141 31.9704 79.3477 41.0401 79.3058 41.8196C79.2471 42.7585 80.8481 43.2027 82.1558 42.3561L102.869 27.5529H109.315V25.0549H102.726L102.718 25.0633Z",
    fill: "url(#paint2_linear_197_6814)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M14.5687 29.7826C8.48311 29.7826 6.70605 26.8069 6.70605 26.8069V88.8782C6.70605 92.5748 9.69856 95.5673 13.3952 95.5673H74.3265V29.7826H14.5687Z",
    fill: "url(#paint3_linear_197_6814)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_197_6814",
    x1: 44.4266,
    y1: 2.80812,
    x2: 44.4266,
    y2: 32.7499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEAEFF",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_197_6814",
    x1: 111.795,
    y1: 61.3338,
    x2: 78.4588,
    y2: 61.6607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEAEFF",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_197_6814",
    x1: 80.4961,
    y1: 60.1351,
    x2: 90.6722,
    y2: 36.631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEAEFF",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_197_6814",
    x1: -5.38968,
    y1: 61.1829,
    x2: 73.3374,
    y2: 61.1829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEAEFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#BEAEFF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#BEAEFF",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#BEAEFF",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEAEFF",
    stopOpacity: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoOn);
export default __webpack_public_path__ + "static/media/VideoOn.512ee43269caba62b6fe8a02bcbf51e6.svg";
export { ForwardRef as ReactComponent };